import getHashCode from '../utils/getHashCode'
import getBase64FromUrl from '../utils/getBase64FromUrl'
import detectAdBlock from '../utils/detectAdBlock'
import getBlobFromUrl from '../utils/getBlobFromUrl'

const MAX_GOOGLE_MAPS_WIDTH = 640
const MAX_GOOGLE_MAPS_HEIGHT = 640
const staticMapCache = {}

const createMapUrl = ({
  gmapKey,
  size,
  position,
  markers,
}) => {
  const staticMapAPI = 'https://maps.googleapis.com/maps/api/staticmap'
  const centerMarker = position ? `color:red|${position.lat},${position.lng}` : null
  const mapMarkers = markers.map(marker => {
    const markerPinUrl = marker.pin ? (
      `markers=icon:${encodeURIComponent(marker.pin)}`
    ) : (
      'markers=color:red'
    )
    return `${markerPinUrl}|${marker.lat},${marker.lng}`
  }).join('&')

  const mapOptions = {
    mapType: 'roadmap',
    format: 'png',
    maptype: 'roadmap',
    scale: 2,
    markers: [centerMarker, mapMarkers].filter(Boolean).join('&'),
    key: gmapKey,
  }

  if (size) mapOptions.size = `${size.width}x${size.height}`

  const qs = Object.keys(mapOptions).map(param => `${param}=${mapOptions[param]}`).join('&')
  const imgSrc = staticMapAPI.concat('?', qs)
  return imgSrc
}

export default async ({
  gmapKey,
  size,
  position,
  markers,
}) => {
  const mapWidth = size.width || MAX_GOOGLE_MAPS_WIDTH
  const mapFeight = size.height || MAX_GOOGLE_MAPS_HEIGHT
  const mapSize = {
    width: mapWidth < MAX_GOOGLE_MAPS_WIDTH ? mapWidth : MAX_GOOGLE_MAPS_WIDTH,
    height: mapFeight < MAX_GOOGLE_MAPS_HEIGHT ? mapFeight : MAX_GOOGLE_MAPS_HEIGHT,
  }

  const mapUrl = createMapUrl({
    gmapKey,
    size: mapSize,
    position,
    markers,
  })
  const hash = getHashCode(mapUrl)
  const getInMemoryImage = () => (
    detectAdBlock()
      ? getBase64FromUrl(mapUrl)
      : getBlobFromUrl(mapUrl)
  )

  if (!staticMapCache[hash]) {
    staticMapCache[hash] = await getInMemoryImage()
  }
  return staticMapCache[hash]
}
